var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary","height":"48"},on:{"click":_vm.onClick}},[_c('img',{staticClass:"mr-2",attrs:{"src":require("@/assets/images/ui/plus.svg"),"alt":""}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }